import { useEffect } from "react"

import { useLocation } from "react-router-dom"

const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    document.getElementById("main-content")?.scrollTo(0, 0)
    document.getElementById("global-wrap")?.scrollTo(0, 0)
  }, [pathname])

  return null
}

export default ScrollToTop
